<template>
  <div>
    <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
        @click="goBack"
      ></el-button>
    <div
      style="
        width: 100%;
        text-align: center;
        font-size: 25px;
        font-weight: bold;
      "
    >
      校长直通车
    </div>
    <div style="justify-content: center">
      <div
        style="
          margin-top: 30px;
          justify-content: center;
          margin-left: 5%;
          margin-right: 5%;
           border-bottom: 1px solid #a0cc97;
            border-right: 1px solid #a0cc97;
        "
      >
        <el-row justify="center" align="middle" style="">
          <el-col :span="2">
            <div class="trcol">反映人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.name }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.bh }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.department }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">
              {{ userInfo.major != null ? userInfo.major : " " }}
            </div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">
              {{ userInfo.bj != null ? userInfo.bj : " " }}
            </div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">身份类型</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">
              {{ userInfo.userType == 0 ? "学生" : "教职工" }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="form" v-loading="loading">
        <el-form ref="form" :model="form" :rules="rules" label-width="130px" >
          <el-row>
            <span style="font-size: 15px; color: red; float: right"
              >系统将自动为您匹配反映类型，如不满意可自行修改</span
            >
            <el-col :span="24">
              <el-form-item label="具体情况描述：" prop="feedContent">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入具体情况描述"
                  v-model="form.feedContent"
                  @blur="changeInput"
                >
                </el-input>
              </el-form-item>
              <!-- <el-form-item label="问题标题：" prop="feedTitle">
                <el-input v-model="form.feedTitle" clearable placeholder="请输入问题标题"></el-input>
              </el-form-item> -->
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="受理部门：" prop="receiveDept">
                <el-select v-model="form.receiveDept" placeholder="请选择受理部门" style="width: 100%" @change="changeDept">
                  <el-option v-for="item in depts" :label="item.label" :value="item" :key="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="反映类型：" prop="feedTypeid">
                <el-select
                  v-model="form.feedTypeid"
                  placeholder="请选择反映类型"
                  style="width: 100%"
                  @change="changeTypeClick"
                >
                  <el-option
                    v-for="item in columnsType"
                    :label="item.label"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="联系方式：" prop="telephone">
                <el-input
                  v-model="form.telephone"
                  clearable
                  placeholder="请输入联系方式"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="是否匿名：" prop="isAnonymous">
                <el-switch v-model="form.isAnonymous" active-value="0" inactive-value="1" active-color="#67C23A">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否公开：" prop="isOpen">
                <el-switch v-model="form.isOpen" active-value="0" inactive-value="1" active-color="#67C23A"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="具体情况描述：" prop="feedContent">
                <el-input type="textarea" :rows="2" placeholder="请输入具体情况描述" v-model="form.feedContent">
                </el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="建议：" prop="advice">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入建议"
                  v-model="form.advice"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传附件：" prop="pics">
                <el-row>
                  <el-col :span="3">
                    <el-upload
                      :action="uploadPath"
                      :before-upload="beforeAvatarUpload"
                      class="avatar-uploader"
                      :data="uploadSettings"
                      :headers="headers"
                      :multiple="false"
                      name="Fdata"
                      :on-success="handleAvatarSuccess"
                      :show-file-list="false"
                      style="float: left"
                    >
                      <!-- <img v-if="filetypeisimg" class="avatar" :src="form.upfile" /> -->

                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <!-- <span v-if="!filetypeisimg">{{ showfile }}</span> -->
                    </el-upload>
                    <!-- </el-form-item> -->

                    <!-- 文件上传展示区 -->
                  </el-col>
                  <el-col :span="21">
                    <div
                      v-for="item in centerArr"
                      :key="item.name"
                      class="avatar"
                      style="position: relative; margin-left: 20px"
                    >
                      <el-image
                        v-if="
                          item.type == 'jpg' ||
                          item.type == 'png' ||
                          item.type == 'gif' ||
                          item.type == 'bmp' ||
                          item.type == 'jpeg'
                        "
                        :key="item.name"
                        height="88px"
                        :preview-src-list="srcList"
                        :src="item.url"
                        width="88px"
                      />
                      <video
                        v-if="item.type == 'MOV' || item.type == 'mp4'"
                        :preload="preload"
                        :height="height"
                        :width="width"
                        align="center"
                        :controls="controls"
                        :autoplay="autoplay"
                        style=""
                        type="video/mp4"
                        :src="item.url"
                      ></video>
                      <i
                        class="close el-icon-error"
                        @click="removeUpfile(item)"
                      ></i>
                    </div>
                  </el-col>
                  <span style="font-size: 15px; color: red; float: right"
                    >最多可上传5个文件，单个文件不大于5MB</span
                  >
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item style="align-items: center; text-align: center">
                <el-button  class="submitClass" @click="onSubmit('form')"
                  >提交</el-button
                >
                <el-button class="colseClass" @click="goBack">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-dialog
        title="智能助手提示"
        :visible.sync="dialogVisible"
        width="40%"
        style="border-radius: 10px;"
      >
        <div style="color: #999999;padding-bottom: 10px;">系统从您的描述中分析出如下关键字，系统自动为您匹配如下关键字，如不正确可自行筛选。</div>
        <el-radio-group v-model="radio" @input="radioChange">
          <el-radio style="word-break: break-all;"  v-for="(item, index) in changeType" :key="index" :label="index">{{item.name+'（'+item.type+'）'}}</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button @click="dialogVisible = false" style="background:#008a2c;color:#fff"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import { 
  saveFeedback,
   queryFeedbackType } from "@/api/xzztc.js";
export default {
  data() {
    return {
      userInfo: "",
      form: {
        feedTitle: "",
        receiveDept: "",
        feedType: "",
        feedTypeid: "",
        feedContent: "",
        advice: "",
        pics: [],
        feedUserid: "",
        receiveDeptid: "",
        isOpen: "",
        isAnonymous: "",
        feedUser: "",
        f1: "0",
        telephone: "",        
      },
      loading:false,
      rules: {
        feedContent: [
          { required: true, message: "请输入具体情况描述", trigger: "blur" },
        ],
        // receiveDept: [
        //   { required: true, message: '请选择受理部门', trigger: 'blur' }
        // ],
        // feedType: [
        //   { required: true, message: '请选择反馈类型', trigger: 'blur' }
        // ],
        telephone: [
          { required: true, message: "请选择反映类型", trigger: "blur" },
        ],
      },
      colStyWidth: "0px",
      columnsType: [],
      depts: [],
      url: "",
      // xzztcToken:"",
      disabled: true,
      describeOld: "",
      radio:0,
      dialogVisible:false,
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      uploadSettings: {
        uploadUrl: "",
        packageName: "/img",
        templateUrl: " ",
        queueLimit: 10,
        fileTypes: ["*"],
        limitSize: 2,
      },
      headers: {
        appkey: "XKES",
      },
      centerArr: [],
      srcList: [],
      playStatus: "",
      muteStatus: "",
      isMute: true,
      isPlay: false,
      width: "88", // 设置视频播放器的显示宽度（以像素为单位）
      height: "88", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: "",
      optionsInput: [],
      changeType:[]
    };
  },
  mounted() {
    // this.userId = window.sessionStorage.getItem("userId");
    this.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    // this.xzztcToken=sessionStorage.getItem("xzztcToken")
    console.log(this.userInfo);
    this.form.feedUser = this.userInfo.name;
    this.form.feedUserid = this.userInfo.bh;
    this.form.telephone = this.userInfo.mobile;
    this.queryFeedbackType();
  },
  methods: {
    //选中匹配的关键字后赋值
    radioChange(index) {
				console.log(index, this.radio);
				this.radio = index
				this.form.feedType = this.changeType[index].type
				this.form.feedTypeid = this.changeType[index].typeId
				this.form.receiveDept = this.changeType[index].department
				this.form.receiveDeptid = this.changeType[index].departmentId
			},
    //获取反馈类型
    queryFeedbackType() {
      this.columnsType = [];
      this.optionsInput = [];
      let data = [];
      let inputs = {};
      let inputArr = [];
      queryFeedbackType().then((res) => {
        if (res.msgCode == 0 && res.data != [] && res.data != null) {
          console.log(res.data);
          res.data.forEach((item) => {
            data.push({
              label: item.feedType,
              id: item.id,
              dept: item.dept,
              deptId: item.deptId,
            });
            inputs = {
              label: item.feedType,
              id: item.id,
              dept: item.dept,
              deptId: item.deptId,
            };
            if (
              item.feedType == "对学校发展战略规划和重大改革工作的意见和建议"
            ) {
              inputs.value = "发展、规划、综合改革";
            }
            if (item.feedType == "对学校领导班子或二级单位工作的意见和建议") {
              inputs.value = "领导、领导班子、院长、书记、部长、主任";
            }
            if (item.feedType == "教学管理") {
              inputs.value =
                "专业、学分、培养方案、课程、必修课、选修课、通识选修课、专业核心课、选课、课表、排课、教材、教学、实验教学、上课、普通话、方言、照着PPT念、照着PPT读、照着课本念、听不懂、课堂纪律、手机、PPT、ppt、作业、调课、停课、教风、实践、实验、实习、毕业论文、毕业设计、答辩、考研、四级、六级、创新学分、课外学分、实习基地、学科竞赛、技能竞赛、竞赛奖励、大创、考试、题目难、考试成绩、作弊、抄袭、答案、监考、考风、学籍、注册、休学、复学、退学、转专业、毕业证、学位证、绩点、成绩单、学业预警、留级、在读证明、学历、学位、学信网、学业导师、教研、教学检查、评教、评估、教务系统、学习通、智慧树";
            }
            if (item.feedType == "科研管理") {
              inputs.value =
                "论文、科研、成果、版面费、横向、纵向、科研经费、社科、自科、社会科学、自然科学、基金";
            }
            if (item.feedType == "师德师风") {
              inputs.value =
                "师德、师德师风、不正当言论、徇私舞弊、侮辱、歧视、威胁、打击报复、教唆、宗教、违背法律、人身攻击，猥亵、骚扰、礼品、兼职、兼薪";
            }
            if (item.feedType == "教师权益") {
              inputs.value =
                "职称、评审、论文、待遇、工资、薪资、福利、评优、评先、晋升、晋级、晋等、培训、实践、企业实践、考核、考评、任务书、分级、聘任、分类、入职、社保、养老保险、饭卡、饭贴、公积金";
            }
            if (item.feedType == "学生权益") {
              inputs.value =
                "助学金、入伍学费补偿、退役复学学费减免、生源地助学贷款、评优评先、社会实践、勤工助学、奖学金、挑战杯、休退学、学风、辅导员、班主任、社团、乐跑、晨跑、晚自习、应征入伍、集体户口、调寝、寝室";
            }
            if (item.feedType == "毕业就业服务") {
              inputs.value =
                "毕业生、就业、简历、面试、招聘、招聘会、就业信息、招聘信息、档案、改派、创业、校友";
            }
            if (item.feedType == "图书馆服务") {
              inputs.value =
                "图书馆、图书、借阅、借书、还书、占座、选座、考研自习室、阅读学分、文献传递、读者讲座";
            }
            if (item.feedType == "后勤服务") {
              inputs.value =
                "水、电、水电、水管、漏水、淹水、灯、开关、环境、噪音、噪声、扰民、装修、工程、施工、地面、地板、地砖、墙、窗户、玻璃、公寓、宿舍、寝室、桌、椅、床、柜、空调、遥控器、电扇、卫生、电梯、鼠、虫、洗衣机、吹风机、开水器、淋浴、转电费、卫生、绿化、充电、水卡、电卡、食堂、虫子、饭、菜、菜价、班车、校车、价格、食品安全卫生、食品安全、食品卫生、医务室、医生、药、驿站、健康驿站、体检、医疗、保险、医保、资产、设备、仪器、产品、质量、采购、菜鸟、快递";
            }
            if (item.feedType == "校园安全") {
              inputs.value =
                "交通、外卖被偷、衣服被偷、偷、人身安全，恐吓，尾随、校园安全、车、停车、挪车，火险，火灾，消防设施，诈骗、外卖";
            }
            if (item.feedType == "教育收费") {
              inputs.value = "学费、收费、缴费、退费";
            }
            if (item.feedType == "社会服务") {
              inputs.value =
                "培训、技能培训、就业技能培训、学徒制、技能竞赛、世界技能竞赛、工匠杯、技能等级认定、考证";
            }
            if (item.feedType == "其他") {
              this.htype = item.feedType;
              this.htypeId = item.id;
              this.hdepartment = item.dept;
              this.hdepartmentId = item.deptId;
            }
            inputArr.push(inputs);
          });
        }
      });
      this.columnsType = data;
      this.optionsInput = inputArr;
      console.log(this.optionsInput, this.columnsType);
    },
    changeInput() {
      if (this.describeOld == this.form.feedContent) {
        return;
      }
      this.describeOld = this.form.feedContent;
      let describe = this.form.feedContent;
      this.changeType = [];
      if (this.optionsInput != null && this.optionsInput != []) {
        for (let i = 0; i < this.optionsInput.length; i++) {
          if (
            this.optionsInput[i].value != null &&
            this.optionsInput[i].value != ""
          ) {
            let arr = this.optionsInput[i].value.split("、");
            if (arr != null) {
              for (let j = 0; j < arr.length; j++) {
                if (describe.indexOf(arr[j]) != -1) {
                  let type = {
                    name: arr[j],
                    type: this.optionsInput[i].label,
                    typeId: this.optionsInput[i].id,
                    department: this.optionsInput[i].dept,
                    departmentId: this.optionsInput[i].deptId,
                    disabled: false,
                  };
                  this.changeType.push(type);
                }
              }
            }
          }
        }
      }
      //去重
      this.changeType = Array.from(
        new Set(this.changeType.map(JSON.stringify)),
        JSON.parse
      );
      console.log(this.changeType);
      if (this.changeType.length > 1) {
        this.form.feedType = this.changeType[0].type;
        this.form.feedTypeid = this.changeType[0].typeId;
        this.form.receiveDept = this.changeType[0].department;
        this.form.receiveDeptid = this.changeType[0].departmentId;
        this.dialogVisible = true;
      } else if (this.changeType.length == 0) {
        this.form.feedType = this.htype;
        this.form.feedTypeid = this.htypeId;
        this.form.receiveDept = this.hdepartment;
        this.form.receiveDeptid = this.hdepartmentId;
      } else {
        this.form.feedType = this.changeType[0].type;
        this.form.feedTypeid = this.changeType[0].typeId;
        this.form.receiveDept = this.changeType[0].department;
        this.form.receiveDeptid = this.changeType[0].departmentId;
      }
      console.log(this.form);
    },
    beforeAvatarUpload(file) {
      const isList = ['image/jpeg', 'image/png', 'image/bmp']
      if (isList.indexOf(file.type) == -1) {
        this.$message.error('上传头像图片只能是 JPG,png,bmp格式!')
        return false
      }
      console.log(file);
      // const isLt2M = file.size / 1024 / 1024 < 10;
      // if (!isLt2M) {
      //   this.$message.error("文件大小不能超过 10MB!");
      //   return false;
      // }
      if (this.form.pics.length >= 5) {
        this.$message.error("文件数量已达上限!");
        return false;
      }
      // return isLt2M
    },
    handleAvatarSuccess(res) {
      // const isList = ['jpeg', 'png', 'bmp', 'jpg', 'gif']
      // if (isList.indexOf(res.object.type) == -1) {
      //   this.filetypeisimg = false //非图片类型
      //   // this.showfile = res.object.originalName
      // } else {
      //   this.filetypeisimg = true
      //   // this.form.upfile = fileAcquisition + res.object.url
      //   // this.$set(this.form, 'upfile', fileAcquisition + res.object.url)
      // }
      // this.imageUrl = 'http://10.5.5.220:8091/upload' + res.object.url

      // this.$set(this.form, 'upfile', this.fileList)
      // this.form = Object.assign({}, this.fileList)
      this.srcList.push(this.fileAcquisition + res.object.url);
      this.centerArr.push({
        name: res.object.originalName,
        type: res.object.type,
        originalUrl: res.object.url,
        url: this.fileAcquisition + res.object.url,
      });
      this.form.pics = this.centerArr;
      console.log(this.centerArr);
    },
    // 删除文件
    removeUpfile(file) {
      console.log(this.centerArr);

      let indexa = "";
      this.centerArr.forEach((item, index) => {
        if (item.url == file.url) {
          indexa = index;
        }
      });
      this.centerArr.splice(indexa, 1);
      this.form.pics = this.centerArr;
      let indexb = "";
      this.srcList.forEach((item, index) => {
        if (item == file.url) {
          indexb = index;
        }
      });
      this.srcList.splice(indexb, 1);
    },
    changeDept() {
      console.log(this.form.receiveDept);
      this.form.receiveDeptid = this.form.receiveDept.id;
      this.form.receiveDept = this.form.receiveDept.label;
      this.form.feedType = "";
      this.disabled = false;
      this.getType();
    },
    changeTypeClick(e) {
      for(let i=0;i<this.columnsType.length;i++){
        if(e==this.columnsType[i].id){
          this.form.feedType = this.columnsType[i].label;
          this.form.receiveDept = this.columnsType[i].dept;
          this.form.receiveDeptid = this.columnsType[i].deptId;
          return
        }
      }
    },
    onSubmit(form) {
      this.loading=true
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.form.feedUser = this.userInfo.name;
          this.form.feedUserid = this.userInfo.bh;
          this.form.f5=this.userInfo.userType
          this.form.pics = JSON.stringify(this.form.pics);
          saveFeedback(this.form).then((res) => {
            // if(data.)
            console.log(res);
            that.form = {
                    feedTitle: "",
                    receiveDept: "",
                    feedType: "",
                    feedTypeid: "",
                    feedContent: "",
                    advice: "",
                    pics: "",
                    feedUserid: "",
                    receiveDeptid: "",
                    isOpen: "",
                    isAnonymous: "",
                    feedUser: "",
                    telephone: that.form.telephone,
                    f1: "0",
                  };
                  that.centerArr = [];
          });
          let that = this;
          this.$confirm(
            "您反映的问题已经提交至系统，我们会尽快受理您的问题，请及时查询微信消息通知关注问题处理进度，如有其他疑问请拨打该咨询电话：027-0999199231",
            "系统提示",
            {
              confirmButtonText: "返回主页",
              cancelButtonText: "继续反映",
              type: "success",
              center: true,
              showClose: false,
              callback: function (action, instance) {
                console.log(instance);
                // 返回主页
                if (action == "confirm") {
                  that.$router.push("/serviceHome");
                }
                // 继续反馈
                if (action == "cancel") {
                 console.log();
                }
              },
              closeOnClickModal: false,
              closeOnPressEscape: false,
              cancelButtonClass: "cancelButtonClass",
              confirmButtonClass: "confirmButtonClass",
            }
          )
            .then(() => {})
            .catch(() => {});
        }
      });
      this.loading=false
    },
    // getDept() {
    //   let data = [];
    //   axios.defaults.headers["authorization"] = this.xzztcToken;
    //   //get，可以设置全局地址提高代码复用率，减少自己写代码，就不用每个都写这么长的地址，嘿嘿
    //   axios.defaults.baseURL = this.url;
    //   axios.get("/api/xzztc/feedback/getDepertment").then((res) => {
    //     // console.log(res.data.data);
    //     if (
    //       res.data.msgCode == 0 &&
    //       res.data.data != [] &&
    //       res.data.data != null
    //     ) {
    //       res.data.data.forEach((item) => {
    //         data.push({
    //           label: item.dept,
    //           value: item.deptId,
    //         });
    //       });
    //     }
    //   });
    //   this.depts = data;
    //   // console.log(this.depts);
    // },
    // getType() {
    //   let data = [];
    //   queryFeedbackType()
    //     .then((res) => {
    //       if (
    //         res.data.msgCode == 0 &&
    //         res.data.data != [] &&
    //         res.data.data != null
    //       ) {
    //         // console.log(res.data);
    //         res.data.data.forEach((item) => {
    //           data.push({
    //             label: item.feedType,
    //             value: item.id,
    //           });
    //         });
    //       }
    //     });
    //   this.types = data;
    // },
    goBack() {
      this.$router.push("/serviceHome");
    },
  },
};
</script>

<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
   border-bottom: none;
    border-right: none;
}

.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-bottom: none;
  border-right: none;
}

.form {
  margin-left: 5%;
  border: 1px solid #dddddd;
  margin-top: 30px;
  padding: 20px;
  margin-right: 5%;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 100px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}
.el-image__error,
.el-image__inner,
.el-image__placeholder {
  width: 100%;
  height: 88px;
}
.close {
  position: absolute;
  right: 0;
  font-size: 20px;
}

.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: white;
}

.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
  background-color: #008a2c;
}

.el-message-box {
  border: 2px solid #008a2c;
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  font-size: 18px;
  box-shadow: 0 2px 12px 0rgba (0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.el-message-box--center .el-message-box__header {
  padding-top: 15px;
}

.colseClass {
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.colseClass:hover,
.colseClass:focus {
  /* padding: 9px 15px; */
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}

.submitClass,
.submitClass:focus {
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.submitClass:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.cancelButtonClass {
  padding: 9px 15px;
  font-size: 12px;
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.cancelButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.confirmButtonClass,
.confirmButtonClass:focus {
  padding: 9px 15px;
  font-size: 12px;
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.confirmButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}
.el-dialog__body {
    padding: 0px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.el-dialog{
  border-radius: 10px;
}
.el-radio__input.is-checked+.el-radio__label {
    color: #008a2c;
}

.el-radio__input.is-checked .el-radio__inner {
    border-color: #008a2c;
    background: #008a2c;
}
</style>